module.exports = __webpack_public_path__ + "img/weixin.174e7e8b.jpg";